import { api } from 'common';

import { AuthorizationSubmissionFormFields } from './FormFields';
import { AuthorizationSubmissionDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const authorizationSubmissionConfig: BlockConfigProps = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'authorizationSubmission',
  defaultConfig: {
    runMode: api.FlowDefinition.RunMode.Live,
    mockScenarioId: '',
    patientLastName: '',
  },
  configFields: {
    schema: api.FlowDefinition.AuthorizationSubmissionBlockConfigSchema,
    FormFields: AuthorizationSubmissionFormFields,
  },
  documentationMarkdown: AuthorizationSubmissionDocumentationMarkdown,
};
